import React, { FC } from 'react'
import styled from 'styled-components';
import Footer from './Footer';
import Navbar from './Navbar';

interface MyProps {

    children: any
}

const Layout: FC< MyProps > = ( props ) => {
    
    return (
        <LayoutWrapper>
            <div className="navbar">
                <Navbar />
            </div>
            <div className="main-content">
            {
                props.children
            }
            </div>
            {/* <div className="footer">
                <Footer />            
            </div> */}
        </LayoutWrapper>
    )
}

export default Layout;

const LayoutWrapper = styled.div`

    min-height: 100vh;
    position: relative;
    .navbar {
        color: white;
    }
    .footer {
        
    }

`;
